import React, { Fragment, useEffect, useState } from "react"
import Carousel from "react-slick"
import styled from "styled-components"
import config from "../../Config"
import { translate } from "react-i18next"
import i18n from "../../i18n"

import {
  fetchData,
  removeData,
  showToast,
  setHeaderTitle,
  saveData,
  showPopup,
  hidePopup,
} from "../../store/action"
import { useDispatch, useSelector } from "react-redux"

import "./carousel.css"

const Title = styled.h2`
  font-family: "montserratRegular";
  text-align: left;
  font-size: 16px;
  font-weight: 500;
  color: #dfe4ff;
`

const TestimonialDiv = styled.div`
  color: white;
  width: 320px;
  height: 143px;
  margin: 0;
  border-radius: 8px;
  display: flex !important;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
`

const Image = styled.div`
  flex: 0.3;
  display: flex;
`

const Text = styled.div`
  display: flex;
  flex: 0.65;
`

// const testimonials = [
//   {
//     id: 1,
//     text:
//       "There are many different ways a business can display customer testimonials. When determining the best approach for your business, it's important to ",
//     src: `${config.BIDNWIN_S3_IMAGE_URL_NEW_UI}/testimonial1.png`,
//   },
//   {
//     id: 2,
//     text:
//       "There are many different ways a business can display customer testimonials. When determining the best approach for your business, it's important to ",
//     src: `${config.BIDNWIN_S3_IMAGE_URL_NEW_UI}/testimonial1.png`,
//   },
//   {
//     id: 3,
//     text:
//       "There are many different ways a business can display customer testimonials. When determining the best approach for your business, it's important to ",
//     src: `${config.BIDNWIN_S3_IMAGE_URL_NEW_UI}/testimonial1.png`,
//   },
// ]

const Testimonial = ({ theme }) => {
  const [testimonials, setTestimonials] = useState([])

  const dispatch = useDispatch()

  useEffect(() => {
    loadData()
  }, [])

  function loadData() {
    console.log("testimonials Auctions load data")
    // const { fetchData, uniqueId, saveData } = this.props
    // console.log("uniqueid 2", uniqueId)
    let uniqueId
    dispatch(
      fetchData({
        uniqueId,
        method: "GET",
        uri: `/testimonials?operatorId=ind`,
        onSuccess: (res) => {
          console.log("testt", res)
          console.log("test", res.testimonials)
          setTestimonials(res.testimonials)
          // if (res && res.auctionDetailsDTO && res.auctionDetailsDTO.auction) {
          //   this.setState({
          //     mainLoader: false,
          //     bids: res.auctionDetailsDTO.auction,
          //   })
          // } else {
          //   this.setState({ mainLoader: false, bids: [] })
          // }
        },
      })
    )
  }

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  }

  console.log("theme props", theme)
  console.log("theme card color", theme.cardColor)

  return (
    testimonials.length > 0 && (
      <div className='testimonial-slider'>
        <Title>{i18n.t("Testimonials")}</Title>
        <Carousel {...settings}>
          {testimonials.map((test, index) => {
            return (
              <TestimonialDiv
                key={index}
                style={{
                  background: `${theme.cardColor}!important`,
                  border: `1px solid ${theme.cardColor}`,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    background: theme.cardColor,
                    borderRadius: "5px",
                    padding: "16px 18px 19px 19px",
                  }}
                >
                  <Image>
                    <img src={test.image} />
                  </Image>
                  <Text>
                    <p
                      style={{
                        textAlign: "left",
                        color: "#dfe4ff",
                        fontFamily: "montserratLight",
                        fontSize: "13px",
                        lineHeight: 1.5,
                      }}
                    >
                      {test.content}
                    </p>
                  </Text>
                </div>
              </TestimonialDiv>
            )
          })}
        </Carousel>
      </div>
    )
  )
}

export default translate("translations")(Testimonial)



// WEBPACK FOOTER //
// ./src/components/carousel/testimonial.js